import React from 'react';
import ReactPlayer from 'react-player/lazy';

const Generic = ({ generic }) => {
    const isImage = generic.endsWith('.jpg') || generic.endsWith('.jpeg') || generic.endsWith('.png')|| generic.endsWith('.webp');
    const isVideo = generic.endsWith('.mp4') || generic.endsWith('.webm') || generic.endsWith('.ogg');

    if (isImage) {
        return (
            <div>
                <img src={generic} style={{ width: "100vw", height: "100vh", objectFit: "cover" }} />
            </div>
        );
    } else if (isVideo) {
        return (
            <div >
                <ReactPlayer
          width="100vw"
          height="100vh"
          playsinline={true}
          className="profile-img"
          playing={true}
          autoPlay
          loop={true}
          controls={false}
          muted={true}
          url={generic}
        />
            </div>
        );
    } else {
        return (
            <div>
                Unsupported content type.
            </div>
        );
    }
}

export default Generic;
